import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
// 配置中文文件
import translation_zh from './zh.json';
// 配置英文的配置文件
import translation_en from './en.json';
// 印度尼西亚语
import translation_id from './id.json';

const resources = {
    en_us:{
        translation:translation_en
    },
    zh_cn:{
        translation:translation_zh
    },
    id_id:{
        translation:translation_id
    }
};
i18n.use(initReactI18next).init({
    resources,
    lng:'en_us',
    interpolation:{
        escapeValue:false
    }
});

export default i18n;